import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSortAmountUpIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M5.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1.0041 1.0041 0 0 0 1.42 1.42l.29-.3V17a1 1 0 1 0 2 0V9.41l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2-2ZM11 8h10a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2Zm10 8H11a1.0001 1.0001 0 0 0 0 2h10a1.0001 1.0001 0 0 0 0-2Zm0-5H11a1.0001 1.0001 0 0 0 0 2h10a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineSortAmountUpIcon
